/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Drop_Zone_LabelInputs */

const en_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag & drop your media file here`)
};

const fr_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glissez-déposez votre fichier multimédia ici`)
};

const de_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehen Sie Ihre Mediendatei per Drag & Drop hierher.`)
};

const it_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascina e rilascia qui il tuo file multimediale`)
};

const ru_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перетащите сюда свой медиафайл.`)
};

const es_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra y suelta tu archivo multimedia aquí.`)
};

const zh_cn2_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将媒体文件拖放到此处`)
};

const ja_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイルをここにドラッグ＆ドロップしてください`)
};

const hi_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी मीडिया फ़ाइल को यहाँ ड्रैग और ड्रॉप करें`)
};

const pt_pt2_new_project_drop_zone_label = /** @type {(inputs: New_Project_Drop_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arraste e solte seu arquivo de mídia aqui.`)
};

/**
* | output |
* | --- |
* | "Drag & drop your media file here" |
*
* @param {New_Project_Drop_Zone_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_drop_zone_label = /** @type {((inputs?: New_Project_Drop_Zone_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Drop_Zone_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_drop_zone_label(inputs)
	if (locale === "de") return de_new_project_drop_zone_label(inputs)
	if (locale === "it") return it_new_project_drop_zone_label(inputs)
	if (locale === "ru") return ru_new_project_drop_zone_label(inputs)
	if (locale === "es") return es_new_project_drop_zone_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_drop_zone_label(inputs)
	if (locale === "ja") return ja_new_project_drop_zone_label(inputs)
	if (locale === "hi") return hi_new_project_drop_zone_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_drop_zone_label(inputs)
	return en_new_project_drop_zone_label(inputs)
});